module.exports = __webpack_public_path__ + "img/Embers-Adrift-2022-005.55eba0c0.jpg";